import { useState, useRef, useEffect } from "react";
import { ORG_IMPORT_MASTER_UPLOAD,ORG_IMPORT_MASTER_TEMPLATES } from '../../../../../ApiServices/BaseURL';
import { getData, postData } from "../../../../../ApiServices/ApiService";

const UploadClientsListFileController = (importMasterList,onRefresh,fileInputRef) => {
    const [tasks, setTasks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5; // Adjust as needed

    const totalPages = Math.ceil(importMasterList?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentTasks = importMasterList?.slice(indexOfFirstItem, indexOfLastItem);
    

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const [importMasterError, setImportMasterError] = useState('');
        const [importMasterLoading, setImportMasterLoading] = useState(false);
        const [importMasterSuccess, setImportMasterSuccess] = useState('');
    const handleFileChange1 = (event) => {
        setImportMasterError('')
        const file = event.target.files[0];
    
        if (file) {
            const reader = new FileReader();
    
            reader.onload = (e) => {
                const text = e.target.result;
                console.log("Raw CSV Text:", text);
    
                const lines = text.split("\n").map(line => line.trim()).filter(line => line !== "");
    
                if (lines.length < 2) {
                    setImportMasterError("Invalid CSV file: Not enough data");
                    return;
                }
    
                let headers = lines[0].split(",").map(header => header.trim());
                console.log("Detected Headers:", headers);
    
                let records = [];
    
                // Read the data rows
                lines.slice(1).forEach((line, index) => {
                    let values = line.split(",").map(value => value.trim());
                    let record = {};
    
                    headers.forEach((header, i) => {
                        record[header] = values[i] || null;
                    });
    
                    records.push(record);
                });
    
                console.log("Extracted Records:", records); 
    
                let payload = {};
    
                // **Determine which type of data this CSV file contains**
                if (headers.includes("client_file_id") && headers.includes("opening_amount")) {
                    payload["Opening_Balance"] = records;
                    console.log(" Detected: Opening Balance Data");
                } else if (headers.includes("client_file_id") && headers.includes("service_name")) {
                    payload["Bulk_Tasks"] = records;
                    console.log(" Detected: Bulk Tasks Data");
                } else if (headers.includes("client_name")) {
                    payload["Bulk_Client_Upload"] = records;
                    console.log(" Detected: Bulk Client Upload Data");
                } else {
                    setImportMasterError(" Unrecognized CSV Format: No matching headers found.");
                    return;
                }
    
                console.log(" Final Extracted Payload:", JSON.stringify(payload, null, 4));
                handleImportMasterUpload(payload);
            };
    
            reader.readAsText(file);
        }
    };

    const handleFileChange = (event) => {
        setImportMasterError('');
        const file = event.target.files[0];
    
        if (file) {
            const reader = new FileReader();
    
            reader.onload = (e) => {
                const text = e.target.result;
                console.log("Raw CSV Text:", text);
    
                const lines = text.split("\n").map(line => line.trim()).filter(line => line !== "");
                console.log("Raw CSV lines:", lines);
    
                if ((lines.length <= 1)) {
                    setImportMasterError("Invalid CSV file: No data found");
                    return;
                }
    
                let originalHeaders = lines[0].split(",").map(header => header.trim());
                console.log("Detected Headers from Uploaded File:", originalHeaders);
    
                let records = [];
                let errorMessages = [];
    
                // **Detect which type of file is uploaded**
                let detectedSheet = null;
                if (originalHeaders.includes("File Number") && originalHeaders.includes("Opening balance")) {
                    detectedSheet = "Opening_Balance";
                } else if (originalHeaders.includes("File Number") && originalHeaders.includes("Services")) {
                    detectedSheet = "Bulk_Tasks";
                } else if (originalHeaders.includes("Client Name")) {
                    detectedSheet = "Bulk_Client_Upload";
                }
    
                if (!detectedSheet) {
                    setImportMasterError("Unrecognized CSV Format: No matching headers found.");
                    return;
                }
    
                console.log(`Detected Sheet Type: ${detectedSheet}`);
    
                // **Header Mapping for Backend Payload**
                const headerMappings = {
                    "Opening_Balance": {
                        "File Number": "client_file_id",
                        "Opening balance": "opening_amount"
                    },
                    "Bulk_Tasks": {
                        "File Number": "client_file_id",
                        "Services": "service_name",
                        "Service Category": "service_sub_name",
                        "Financial Year": "financial_year",
                        "Period": "financial_period",
                        "Start Date": "task_start_date",
                        "Due Date": "task_due_date",
                        "Estimated Invoice Amount": "invoice_amt_estimated",
                        "Agreed Invoice Amount": "invoice_amt_agreed",
                        "Description": "task_description"
                    },
                    "Bulk_Client_Upload": {
                        "Client Name": "client_name",
                        "Client Type": "client_type_name",
                        "Identification Type": "client_identity_doc_id",
                        "Identification Number": "client_identity_doc_id_number",
                        "Date of Enrollment": "client_enrolled_on",
                        "Group Name": "group_name",
                        "Address": "client_address",
                        "City": "client_city",
                        "State": "client_state",
                        "Pin Code": "client_pin",
                        "Mobile Number": "client_mobile_no",
                        "GSTIN": "client_gstin",
                        "Aadhar Number": "client_aadhar_no",
                        "PAN": "client_pan_no",
                        "Client Assigned User": "emp_id_incharge_name",
                        "NRI": "is_india_client",  // Convert Yes/No to 1/0
                        "E-mail Id": "client_email",
                        "Primary Contact Name": "contact_name",
                        "Primary Contact Phone Number": "contact_phone_no",
                        "Primary Contact E-mail id": "contact_email",
                        "Primary Contact Role": "contact_role"
                    }
                };
    
                let mappedHeaders = headerMappings[detectedSheet];
    
                lines.slice(1).forEach((line, rowIndex) => {
                    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                    let values = line.split(",").map(value => value.trim());
                    let record = { emp_id_auth: storedUserInfo?.emp_id }; // Add `emp_id_auth` as the first key
    
                    originalHeaders.forEach((header, i) => {
                        let backendHeader = mappedHeaders[header] || header; // Map headers or keep original
    
                        let value = values[i] || null;
    
                        // Convert "Yes" -> 1, "No" -> 0 for `is_india_client`
                        if (backendHeader === "is_india_client") {
                            value = value?.toLowerCase() === "yes" ? 1 : 0;
                        }
    
                        record[backendHeader] = value;
                    });
    
                    // **Validation Check**
                    if (detectedSheet === "Opening_Balance") {
                        let requiredFields = ["client_file_id", "opening_amount"];
    
                        let missingFields = requiredFields.filter(field =>
                            !record[field] || record[field].toString().trim() === "" || record[field] === undefined
                        );
    
                        if (missingFields.length > 0) {
                            errorMessages = [`Missing required fields: ${missingFields.join(", ")}`];
                        }
                    }
                    
    
                    if (detectedSheet === "Bulk_Client_Upload") {
                        let requiredFields = [
                            "client_name", "client_type_name", "client_identity_doc_id", "client_identity_doc_id_number",
                            "client_mobile_no", "client_address", "client_city", "client_state", "client_gstin",
                            "client_aadhar_no", "client_email", "emp_id_incharge_name", "is_india_client"
                        ];
                    
                        let missingFields = requiredFields.filter(field => 
                            record[field] === null || record[field] === "" || record[field] === undefined
                        );
                    
                        if (missingFields.length > 0) {
                            errorMessages = [`Missing required fields: ${missingFields.join(", ")}`]; // Reset & set single message
                        }
                    }

                    if (detectedSheet === "Bulk_Tasks") {
                        let requiredFields = [
                            "client_file_id", "service_name", "service_sub_name", "financial_year",
                            "financial_period", "task_start_date", "task_due_date",
                        ];
                    
                        let missingFields = requiredFields.filter(field => 
                            record[field] === null || record[field] === "" || record[field] === undefined
                        );
                    
                        if (missingFields.length > 0) {
                            errorMessages = [`Missing Rrquired fields: ${missingFields.join(", ")}`]; // Reset & set single message
                        }
                    }
                    
                    
    
                    records.push(record);
                });
    
                if (errorMessages.length > 0) {
                    setImportMasterError(errorMessages);
                    return;
                }
    
                // ** Final Payload Structure**
                let payload = {
                    [detectedSheet]: records
                };
    
                console.log("Final Payload for Backend:", JSON.stringify(payload, null, 4));
                handleImportMasterUpload(payload);
                event.target.value = null;
            };
    
            reader.readAsText(file);
        }
    };
    
    

        const handleImportMasterUpload = async (payload) => {
            // console.log("apply values", groupName?.value, clientType?.value, cleintAssignedUser?.value, nri?.value, address, location, state?.value, pinCode,);
            // return
            // console.log("location:", typeof location, location);
            try {
    
                // setError('');
                setImportMasterError('')
                setImportMasterSuccess('');
    
                // if(!groupName && !clientType && !cleintAssignedUser && !nri && !address && !selectedLocation && !location.trim()  && !state && !pinCode && !base64File){
                //     setBulkUpdateOfClientInformationError('Please select at least one feild');
                //     return
                // }
                setImportMasterLoading(true);
    
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                // const payLoad = {
                //     "action": "bulk_update",
                //     emp_id_auth: storedUserInfo?.emp_id,
                //     doc_name:uploadedFileName?.split('.')[0],
                //     doc_base_64: base64File,
                //     doc_name_with_ext: uploadedFileName,
                //     // client_name: nameOfClient,
                //     group_id: groupName?.value || 0,
                //     emp_id_incharge:cleintAssignedUser?.value ||0,
                //     client_type_id: clientType?.value ||0,
                //     is_india_client: nri?.value ||0,
                //     client_address:address ||'',
                //     client_city:location ||'',
                //     client_state: state?.label ||'',
                //     client_pin: pinCode ||'',
                //     doc_is_internal: 1,
                //     client_id: selectedClients
                // }
    
                console.log('handle Bulk Update Of CLient Information payload', payload);
                // return
                // Make the API call
                const response = await postData(ORG_IMPORT_MASTER_UPLOAD, payload);
                const responseData = await response.json();
                //console.log('response Data', responseData);
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            setImportMasterError('')
                            setImportMasterSuccess(responseData?.info);
                            onRefresh();
                            // clearFeilds();
                            setTimeout(() => {
                                // handleClose();
                                // handleCancleClick();
                                // onValueChange();
                                setImportMasterSuccess('');
                            }, 3000);
                        } else {
                            setImportMasterError(responseData?.info || 'Failed to add notice board message. Please try again.');
                        }
                    } else {
                        setImportMasterError(responseData?.info || 'Failed to add notice board message. Status code error.');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                        setImportMasterError('Unauthorized access. Your session may have expired. Please log in again.');
                        // Optionally, redirect to the login page or refresh the token
                        // Example: redirectToLogin();
                    } else {
                        setImportMasterError(responseData?.info || 'Bad request. Please check the request parameters.');
                    }
                }
                // Internal Server Error: 500
                else if (response?.status === 500) {
                    setImportMasterError(responseData?.info || 'Internal Server Error. Please try again later.');
                }
                // Unexpected or network-related errors
                else {
                    setImportMasterError('Unexpected error occurred. Please try again later.');
                }
            } catch (error) {
                // Handle various error scenarios
                if (error.response) {
                    // Server responded with a status outside the 2xx range
                    setImportMasterError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to add notice board message. Please try again.'}`);
                } else if (error.request) {
                    // Request was made but no response was received
                    setImportMasterError('No response received from the server. Please check your network connection and try again.');
                } else {
                    // An error occurred in setting up the request
                    setImportMasterError(`Failed to add notice board message. Please check your network connection and try again.`);
                }
            } finally {
                setImportMasterLoading(false);
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
            }
    
            // onValueChange(teamData);
            // onClose();
        };

        // const [importMasterTemplateLink, setImportMasterTemplateLink] = useState([]);
        const [importMasterTemplateError, setImportMasterTemplateError] = useState('');
        const [importMasterTemplatesLoading, setImportMasterTemplatesLoading] = useState(false)
        const handleImportMasterTemplates = async (option) => {
            try {
                setImportMasterTemplatesLoading(true);
                setImportMasterTemplateError('');
                const payloadMapping = {
                    "Bulk Client Upload": "client_import",
                    "Bulk Task Upload": "task_import",
                    "Opening Balance": "opening_balance_import",
                };
    
                const payload = {
                    file: payloadMapping[option],
                };
    
                console.log('handle Bulk Update Of CLient Information payload', payload);
                // return
                // Make the API call
                const response = await postData(ORG_IMPORT_MASTER_TEMPLATES, payload);
                const responseData = await response.json();
                //console.log('response Data', responseData);
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            setImportMasterTemplateError('')
                            const downloadUrl = responseData.dataJ[0]?.download_url;
                            downloadFile(downloadUrl);
                        } else {
                            setImportMasterTemplateError(responseData?.info || 'Failed to add notice board message. Please try again.');
                        }
                    } else {
                        setImportMasterTemplateError(responseData?.info || 'Failed to add notice board message. Status code error.');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                        setImportMasterTemplateError('Unauthorized access. Your session may have expired. Please log in again.');
                        // Optionally, redirect to the login page or refresh the token
                        // Example: redirectToLogin();
                    } else {
                        setImportMasterTemplateError(responseData?.info || 'Bad request. Please check the request parameters.');
                    }
                }
                // Internal Server Error: 500
                else if (response?.status === 500) {
                    setImportMasterTemplateError(responseData?.info || 'Internal Server Error. Please try again later.');
                }
                // Unexpected or network-related errors
                else {
                    setImportMasterTemplateError('Unexpected error occurred. Please try again later.');
                }
            } catch (error) {
                // Handle various error scenarios
                if (error.response) {
                    // Server responded with a status outside the 2xx range
                    setImportMasterTemplateError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to add notice board message. Please try again.'}`);
                } else if (error.request) {
                    // Request was made but no response was received
                    setImportMasterTemplateError('No response received from the server. Please check your network connection and try again.');
                } else {
                    // An error occurred in setting up the request
                    setImportMasterTemplateError(`Failed to add notice board message. Please check your network connection and try again.`);
                }
            } finally {
                setImportMasterTemplatesLoading(false);
            }
    
            // onValueChange(teamData);
            // onClose();
        };

        const downloadFile = (url) => {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Schedule Report.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        
    const maxVisiblePages = 3;
    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);
        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();
    
    return {
        tasks: currentTasks,
        currentPage,
        totalPages, visiblePages,
        handlePageChange,
        handleFileChange,
        importMasterSuccess,
        importMasterLoading,
        importMasterError,
        downloadFile,
        handleImportMasterTemplates,
        importMasterTemplatesLoading,
        importMasterTemplateError
    };
};

export default UploadClientsListFileController;
